import * as React from 'react';
import { withRouter } from 'react-router';
class ScrollToTop extends React.Component {
    componentDidUpdate(prevProps) {
        // Browser back/forward (POP) intentionally does NOT reset scroll — the point of going back
        // is to return to where you were (e.g. a search results list after opening a car's VDP), not
        // to jump to the top of the previous page. Only PUSH/REPLACE (following a link, opening a
        // detail page) scrolls to top, matching normal multi-page-site behavior. Pages that want to
        // restore an exact prior scroll offset on POP (see SearchNextPage) handle that themselves.
        if (this.props.location.pathname !== prevProps.location.pathname && this.props.history.action !== 'POP') {
            window.scrollTo(0, 0);
        }
    }
    render() {
        return null;
    }
}
export default withRouter(ScrollToTop);
